import React from 'react';
import './App.css';



function App() {
  return (
    <div className="App">
      <div className="background"></div> {/* Capa de fondo con la imagen */}
      <div className="overlay"></div> {/* Capa oscura */}      
    </div>
  );
}

export default App;
